export default "__VITE_ASSET__Dq3QQ4L9__"